// Mui
import { Theme } from '@mui/material/styles';
import { Dialog, DialogContent, DialogProps, Divider, Typography, useMediaQuery } from '@mui/material';

// components
import { FormikTextInput } from 'components/FormikInput';
import DialogHeader from 'components/DialogHeader';
import DialogForm from 'components/DialogForm';

// types
import { YupShape } from 'types/yup';

// third-parties
import { Formik } from 'formik';
import * as Yup from 'yup';

export interface CloseNotificationConfirmProps extends Omit<DialogProps, 'onClose'> {
  onOK?: (value?: string) => void;
  onClose?: () => void;
  userId?: number;
  note?: string | null;
}

interface FormValues {
  note: string | undefined;
}

function CloseNotificationConfirm({ userId, note, onClose, onOK, ...others }: CloseNotificationConfirmProps) {
  const matchDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const initialValues: FormValues = {
    note: ''
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 600, maxHeight: 800 } }}
      maxWidth={matchDownMD ? 'sm' : 'lg'}
      {...others}
      onClose={() => handleClose()}
    >
      <DialogHeader onClose={() => handleClose()}>{note ? 'Alert Note' : 'Close Alert'}</DialogHeader>
      <Divider />
      {note ? (
        <DialogContent>
          <Typography>{note}</Typography>
        </DialogContent>
      ) : (
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={Yup.object<YupShape<FormValues>>({
            note: Yup.string()
          })}
          onSubmit={async (rawValues) => {
            onOK?.(rawValues.note);
          }}
        >
          {({ handleSubmit, isSubmitting }) => {
            return (
              <form noValidate onSubmit={handleSubmit}>
                <DialogForm
                  onClickCancel={() => handleClose()}
                  isSubmitting={isSubmitting}
                  items={[
                    <FormikTextInput
                      name="note"
                      label="Note"
                      id="note"
                      placeholder="Please enter note"
                      textInputProps={{ multiline: true, rows: 5 }}
                    />
                  ]}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Dialog>
  );
}

export default CloseNotificationConfirm;
